<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="widget">
          <div class="form-elements-sec">
            <div class="widget-title">
              <h3>Kullanıcı Ekle</h3>
            </div>
            <div class="row">

              <div class="col-md-6">
                <div class="form-group">
                  <label for="first_name">Ad</label>
                  <input
                    type="text"
                    v-model="first_name"
                    class="form-control custom-input"
                  >
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="last_name">Soyad</label>
                  <input
                    type="text"
                    v-model="last_name"
                    class="form-control custom-input"
                  >
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">E-posta</label>
                  <input type="text" v-model="email" class="form-control custom-input" placeholder>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="password">Şifre</label>
                  <input
                    type="password"
                    v-model="password"
                    class="form-control custom-input"
                    placeholder
                  >
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for></label>
                  <button class="btn btn-success pull-right" @click="addData">Kaydet</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      api: "panel_users",
      first_name: "",
      last_name: "",
      email: "",
      password: "",
    };
  },
  methods: {
    addData() {
      this.axios
        .post(this.api, {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          password: this.password,
        })
        .then(response => {
          if (response.status == 201) {
            this.$router.push({
              name: "panel_users.update",
              params: { id: response.data.id }
            });
          }
        });
    }
  }
};
</script>

<style scoped>
</style>